import { render, staticRenderFns } from "./Yarns.vue?vue&type=template&id=3eff4e86&scoped=true&"
import script from "./Yarns.vue?vue&type=script&lang=js&"
export * from "./Yarns.vue?vue&type=script&lang=js&"
import style0 from "./Yarns.vue?vue&type=style&index=0&id=3eff4e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff4e86",
  null
  
)

export default component.exports